import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

import { SessionService } from "./storage/session.service";

import { MenuLink, NavgiationLink, NavigationSubNav, NavigationTopNav } from "src/app/models/navigation";
import { AgentPaths, MemberPaths } from "src/app/constants/routes";
import { SvgMatType, SVGNavBarColors } from "src/app/constants/icons";
import { InPageNavItem } from "../models/in-page-nav";

@Injectable()
export class NavigationService {

    public $TopNavMenu = new BehaviorSubject(new NavigationTopNav());
    public $SubNavMenu = new BehaviorSubject(new NavigationSubNav());

    constructor(
        private sessionService: SessionService,
    ) {
    }

    public buildNavMenu(url: string): void {
        if (this.sessionService.session.isLoggedIn) {
            if (this.sessionService.session.isAgent && !this.sessionService.session.isMember) {
                this.buildAgentNav(url);
            } else if (this.sessionService.session.isMember) {
                this.buildMemberNav(url);
            } else {
                this.$TopNavMenu.next(new NavigationTopNav());
                this.$SubNavMenu.next(new NavigationSubNav());
            }
        }
    }

    private buildAgentNav(url: string) {
        let l_TopNavgiationLinks: NavgiationLink[] = [
            {
                label: 'Member',
                link: AgentPaths.CounselorMember,
                svg: SvgMatType.SearchUsers,
                menuLinks: this.BuildAgentMenuLinks(AgentPaths.CounselorMember)
            },
            // {
            //     label: 'Call Logs',
            //     link: AgentPaths.CallLogs,
            //     svg: SvgMatType.Phone,
            //     menuLinks: this.BuildAgentMenuLinks(AgentPaths.CallLogs)
            // },
            // {
            //     label: 'Follow Ups',
            //     link: AgentPaths.FollowUps,
            //     svg: SvgMatType.SyncAlt,
            //     menuLinks: this.BuildAgentMenuLinks(AgentPaths.FollowUps)
            // },
            {
                label: 'Resources',
                link: AgentPaths.Resources,
                svg: SvgMatType.Resources,
                menuLinks: this.BuildAgentMenuLinks(AgentPaths.Resources)
            },
            {
                label: 'Reports',
                link: AgentPaths.Reports,
                svg: SvgMatType.Reports,
                menuLinks: this.BuildAgentMenuLinks(AgentPaths.Reports)
            },
        ];

        if (this.sessionService.session.agent.isSupervisor || this.sessionService.session.agent.hasAccessToAllBrokers)
            l_TopNavgiationLinks.push(
            {
                label: 'Agents',
                link: AgentPaths.Agents,
                svg: SvgMatType.ManageAccounts,
                menuLinks: this.BuildAgentMenuLinks(AgentPaths.Agents)
            });

        const l_NavigationTopNav: NavigationTopNav = {
            links: l_TopNavgiationLinks,
        };

        this.$TopNavMenu.next(l_NavigationTopNav);
    }

    private BuildAgentMenuLinks(url: string): MenuLink[] {
        let l_MenuLinks: MenuLink[];
        switch (true) {
            case url.startsWith(AgentPaths.CounselorMember):
                l_MenuLinks = [
                    {
                        label: 'Member Lookup',
                        link: AgentPaths.CounselorMemberLookup,
                    },
                    {
                        label: 'Lookup History',
                        link: AgentPaths.CounselorMemberLookupHistory,
                    },
                    {
                        label: 'Test Members',
                        link: AgentPaths.CounselorMemberTestMembers,
                    },
                    {
                        label: 'Create',
                        link: AgentPaths.CounselorMemberCreate,
                    },];
                break;

            // case url.startsWith(AgentPaths.CallLogs):
            //     l_MenuLinks = [
            //         {
            //             label: 'Call Log History',
            //             link: AgentPaths.CallLogHistory,
            //         },
            //         {
            //             label: 'Create Call Log',
            //             link: AgentPaths.CallLogsCreate,
            //         },
            //     ];
            //     break;

            // case url.startsWith(AgentPaths.FollowUps):
                l_MenuLinks = [
                    {
                        label: 'Open Follow Ups',
                        link: AgentPaths.FollowUpsOpen,
                    },
                    {
                        label: 'Completed Follow Ups',
                        link: AgentPaths.FollowUpsCompleted,
                    },
                    {
                        label: 'Follow Up Management',
                        link: AgentPaths.FollowUpManagement,
                    }
                ];
                break;

            case url.startsWith(AgentPaths.Resources):
                l_MenuLinks = [
                    {
                        label: 'Benefits',
                        link: AgentPaths.ResourcesBenefitLevel,
                    },
                    {
                        label: 'Company',
                        link: AgentPaths.ResourcesCompanyLevel,
                    },
                    {
                        label: 'Compliance',
                        link: AgentPaths.ResourcesCompliance,
                    },
                    {
                        label: 'Contacts',
                        link: AgentPaths.ResourcesContacts,
                    }
                ];
                break;

            case url.startsWith(AgentPaths.Reports):
                l_MenuLinks = [
                    {
                        label: 'Execute Reports',
                        link: AgentPaths.ReportsExecute,
                    },
                    {
                        label: 'Today\'s Reports',
                        link: AgentPaths.ReportsToday,
                    },
                    {
                        label: 'Report History',
                        link: AgentPaths.ReportsHistory,
                    }
                ];
                break;

            case url.startsWith(AgentPaths.Agents):
                l_MenuLinks = [
                    {
                        label: 'Agents',
                        link: AgentPaths.AgentsManage,
                    },
                    {
                        label: 'Company Assignment',
                        link: AgentPaths.AgentsCompanyAssignment,
                    },
                    {
                        label: 'Agent Assignment',
                        link: AgentPaths.AgentsAssignment,
                    },
                    {
                        label: 'Carrier Info',
                        link: AgentPaths.AgentsCarrierInfo,
                    },
                ];

                if (this.sessionService.session.agent.hasAccessToAllBrokers)
                    l_MenuLinks.push(
                        {
                            label: 'Server Tests',
                            link: AgentPaths.AgentsTestServers,
                        },
                        {
                            label: 'Authenticator Tests',
                            link: AgentPaths.AuthenticatorTest,
                        },
                        {
                            label: 'SASS Reviews',
                            link: AgentPaths.AgentsReviewSASS,
                        },
                    );
                break;
        }

        return l_MenuLinks;
    }

    private buildMemberNav(url: string) {
        let l_TopNavgiationLinks: NavgiationLink[] = [
            {
                label: 'Dashboard',
                link: MemberPaths.Dashboard,
                svg: SvgMatType.Home,
                menuLinks: this.BuildMemberMenuLinks(MemberPaths.Dashboard),
                isIconOnly: true
            }
        ];

        if (this.sessionService.session.member.usePayrollModule && !this.sessionService.session.isAgent)
            l_TopNavgiationLinks.push(
                {
                    label: 'Payroll',
                    link: MemberPaths.Payroll,
                    svg: SvgMatType.RequestQuote,
                    menuLinks: this.BuildMemberMenuLinks(MemberPaths.Payroll)
                }
            );

        l_TopNavgiationLinks.push(
            {
                label: 'Benefits',
                link: MemberPaths.Benefits,
                svg: SvgMatType.SquareCross,
                menuLinks: this.BuildMemberMenuLinks(MemberPaths.Benefits)
            },
            {
                label: 'Profile',
                link: MemberPaths.Profile,
                svg: SvgMatType.Profile,
                menuLinks: this.BuildMemberMenuLinks(MemberPaths.Profile)
            }
        );

        // if (this.sessionService.session.member.showMemberAccounting || this.sessionService.session.member.isUSAePayEnabled) {
        //     l_TopNavgiationLinks.push(
        //         {
        //             label: 'Accounting',
        //             link: this.sessionService.session.member.showMemberAccounting ? MemberPaths.Accounting : MemberPaths.AccountingPaymentInformation,
        //             svg: SvgMatType.AccountBalance,
        //             menuLinks: this.BuildMemberMenuLinks(MemberPaths.Accounting)
        //         }
        //     );
        // }

        l_TopNavgiationLinks.push(
            {
                label: 'Resources',
                link: MemberPaths.Documents,
                svg: SvgMatType.Resources,
                menuLinks: this.BuildMemberMenuLinks(MemberPaths.Documents)
            }
        ); 

        // if (this.sessionService.session.isAgent) {
        //     l_TopNavgiationLinks.push(
        //         {
        //             label: 'Relations',
        //             link: MemberPaths.Relations,
        //             svg: SvgMatType.Clipboard,
        //             menuLinks: this.BuildMemberMenuLinks(MemberPaths.Relations)
        //         }
        //     );
        // }

        const l_NavigationTopNav: NavigationTopNav = {
            links: l_TopNavgiationLinks,
        };

        this.$TopNavMenu.next(l_NavigationTopNav);
    }

    private BuildMemberMenuLinks(url: string): MenuLink[] {

        let l_MenuLinks: MenuLink[];
        switch (true) {
            case url.startsWith(MemberPaths.Dashboard):
                l_MenuLinks = null;
                break;

            case url.startsWith(MemberPaths.Benefits):
                l_MenuLinks = [
                    {
                        label: 'Benefits Dashboard',
                        link: MemberPaths.BenefitsDashboard,
                    },{
                        label: 'Available Benefits',
                        link: MemberPaths.BenefitsAvailable,
                    },{
                        label: 'My Benefits',
                        link: MemberPaths.BenefitsMyBenefits,
                    },{
                        label: 'Beneficiaries',
                        link: MemberPaths.BenefitsBeneficiaries,
                    },
                ];

                if (this.sessionService.session.member.useYearRound)
                    l_MenuLinks.push({
                        label: 'Life Event Requests',
                        link: MemberPaths.BenefitsLifeEventRequests,
                    });

                if (this.sessionService.session.member.showDependentVerification)
                    l_MenuLinks.push({
                        label: 'Dependent Verification',
                        link: MemberPaths.BenefitsDependentVerification,
                    });

                if (this.sessionService.session.member.isUSAePayEnabled)
                    l_MenuLinks.push({
                        label: 'Payment Informaiton',
                        link: MemberPaths.PaymentInformation,
                    });

                l_MenuLinks.push({
                        label: 'Benefit Summaries',
                        link: MemberPaths.DocumentsBenefitsSummaries
                    },{
                        label: 'Change Requests',
                        link: MemberPaths.BenefitsChangeRequests,
                    },
                );
                break;

            case url.startsWith(MemberPaths.Profile):
                l_MenuLinks = [
                    {
                        label: 'Member',
                        link: MemberPaths.ProfileMember,
                    },{
                        label: 'Dependents',
                        link: MemberPaths.ProfileDependents,
                    },{
                        label: 'Beneficiaries',
                        link: MemberPaths.ProfileBeneficiaries,
                    },
                ];
                break;

            case url.startsWith(MemberPaths.Accounting):
                l_MenuLinks = [];
                if (this.sessionService.session.member.showMemberAccounting)
                    l_MenuLinks.push({
                        label: 'Accounting Transations',
                        link: MemberPaths.AccountingTransactions,
                    });

                if (this.sessionService.session.member.isUSAePayEnabled)
                    l_MenuLinks.push({
                        label: 'Payment Informaiton',
                        link: MemberPaths.AccountingPaymentInformation,
                    });
                break;

            case url.startsWith(MemberPaths.Documents):
                l_MenuLinks = [
                    {
                        label: 'Benefits',
                        link: MemberPaths.DocumentsBenefits,
                    },{
                        label: 'Company',
                        link: MemberPaths.DocumentsCompany,
                    },{
                        label: 'Compliance',
                        link: MemberPaths.DocumentsCompliance,
                    },{
                        label: 'Contacts',
                        link: MemberPaths.DocumentsContacts,
                    },
                ];

                if (this.sessionService.session.member.useACAModule)
                    l_MenuLinks.push({
                        label: 'Form 1095s',
                        link: MemberPaths.DocumentsForm1095
                    });

                 if (this.sessionService.session?.member?.usePayrollModule && !this.sessionService.session.isAgent)
                    l_MenuLinks.push({
                        label: 'W2\'s',
                        link: MemberPaths.DocumentsW2
                    });
                break;

            case url.startsWith(MemberPaths.Relations):
                l_MenuLinks = [
                    {
                        label: 'Activity Log',
                        link: MemberPaths.RelationsActivityLog,
                    },{
                        label: 'Open Follow Ups',
                        link: MemberPaths.RelationsOpenFollowUps,
                    },{
                        label: 'Completed Follow Ups',
                        link: MemberPaths.RelationsCompletedFollowUps,
                    },
                ];
                break;

            case url.startsWith(MemberPaths.Payroll):
                l_MenuLinks = [
                    {
                        label: 'Dashboard',
                        link: MemberPaths.PayrollDashboard
                    },{
                        label: 'Pay Stubs',
                        link: MemberPaths.PayrollPayStubs,
                    },{
                        label: 'Annual Statements',
                        link: MemberPaths.PayrollAnnualStatements,
                    },{
                        label: 'Address',
                        link: MemberPaths.PayrollAddress,
                    },{
                        label: 'Deductions',
                        link: MemberPaths.PayrollDeductions,
                    },{
                        label: 'Direct Deposit',
                        link: MemberPaths.PayrollDirectDeposit,
                    },{
                        label: 'Federal Tax Details',
                        link: MemberPaths.PayrollFederalTaxDetails,
                    },{
                        label: 'State Tax Details',
                        link: MemberPaths.PayrollStateTaxDetails,
                    },{
                        label: 'PTO/ Sick Hours',
                        link: MemberPaths.PayrollPTOSickHours,
                    },
                ];
                break;
        }

        return l_MenuLinks;
    }


    public buildAgentPageNavItems(url: string): InPageNavItem[] {
        let l_AgentInPageNavItems: InPageNavItem[] = new Array<InPageNavItem>();

        let l_MenuLinks: MenuLink[];
        switch (true) {
            case url.startsWith(AgentPaths.CounselorMember):
                l_AgentInPageNavItems.push({ 
                        icon: SvgMatType.MemberLookup, 
                        label: 'Member Lookup', 
                        key: 'memberLookup', 
                        route: AgentPaths.CounselorMemberLookup, 
                        customClass: SVGNavBarColors.iconBlue 
                    },{
                        icon: SvgMatType.LookupHistory,
                        label: 'Lookup History',
                        key: 'Lookup History',
                        route: AgentPaths.CounselorMemberLookupHistory,
                        customClass: SVGNavBarColors.iconMint
                    },{
                        icon: SvgMatType.TestMembers,
                        label: 'Test Members',
                        key: 'testMembers',
                        route: AgentPaths.CounselorMemberTestMembers,
                        customClass: SVGNavBarColors.iconCoral
                    },{
                        icon: SvgMatType.MemberCreate,
                        label: 'Member Create',
                        key: 'MemberCreate',
                        route: AgentPaths.CounselorMemberCreate,
                        customClass: SVGNavBarColors.iconCyan
                    },
                );
                break;

            case url.startsWith(AgentPaths.Resources):
                l_AgentInPageNavItems.push({ 
                        icon: SvgMatType.BenefitDocs, 
                        label: 'Benefit Docs', 
                        key: 'benefits', 
                        route: AgentPaths.ResourcesBenefitLevel, 
                        customClass: SVGNavBarColors.iconBlue 
                    },{ 
                        icon: SvgMatType.Company,
                        label: 'Company Docs',
                        key: 'company',
                        route: AgentPaths.ResourcesCompanyLevel,
                        customClass: SVGNavBarColors.iconMint 
                    },{
                        icon: SvgMatType.ComplianceDocs,
                        label: 'Compliance Docs',
                        key: 'compliance',
                        route: AgentPaths.ResourcesCompliance,
                        customClass: SVGNavBarColors.iconCoral
                    },{
                        icon: SvgMatType.Contacts,
                        label: 'Contacts',
                        key: 'contacts',
                        route: AgentPaths.ResourcesContacts,
                        customClass: SVGNavBarColors.iconLavender 
                    }
                );
                break;

            case url.startsWith(AgentPaths.Reports):
                l_AgentInPageNavItems.push({ 
                        icon: SvgMatType.ExecuteReports, 
                        label: 'Execute Reports', 
                        key: 'executeReports', 
                        route: AgentPaths.ReportsExecute, 
                        customClass: SVGNavBarColors.iconBlue 
                    },{ 
                        icon: SvgMatType.Company,
                        label: 'Today\'s Reports',
                        key: 'todaysReports',
                        route: AgentPaths.ReportsToday,
                        customClass: SVGNavBarColors.iconMint 
                    },{
                        icon: SvgMatType.ComplianceDocs,
                        label: 'Reports History',
                        key: 'reportsHistory',
                        route: AgentPaths.ReportsHistory,
                        customClass: SVGNavBarColors.iconCoral
                    },
                );
                break;

            case url.startsWith(AgentPaths.Agents):
                l_AgentInPageNavItems.push({ 
                        icon: SvgMatType.Agents, 
                        label: 'Agents', 
                        key: 'agents', 
                        route: AgentPaths.AgentsManage, 
                        customClass: SVGNavBarColors.iconBlue 
                    },{ 
                        icon: SvgMatType.CompanyAssignment,
                        label: 'Company Assignment',
                        key: 'companyAssignment',
                        route: AgentPaths.AgentsCompanyAssignment,
                        customClass: SVGNavBarColors.iconMint 
                    },{
                        icon: SvgMatType.AgentsAssignment,
                        label: 'Agents Assignment',
                        key: 'agentsAssignment',
                        route: AgentPaths.AgentsAssignment,
                        customClass: SVGNavBarColors.iconCoral
                    },{
                        icon: SvgMatType.CarrierInfo,
                        label: 'Carrier Info',
                        key: 'carrierInfo',
                        route: AgentPaths.AgentsCarrierInfo,
                        customClass: SVGNavBarColors.iconCyan
                    }
                );

                if (this.sessionService.session.agent.hasAccessToAllBrokers)
                    l_AgentInPageNavItems.push({ 
                            icon: SvgMatType.ServerTests, 
                            label: 'Server Tests', 
                            key: 'serverTests', 
                            route: AgentPaths.AgentsTestServers, 
                            customClass: SVGNavBarColors.iconLavender 
                        },{ 
                            icon: SvgMatType.SASSReviews, 
                            label: 'SASS Reviews', 
                            key: 'sassReviews', 
                            route: AgentPaths.AgentsReviewSASS, 
                            customClass: SVGNavBarColors.iconGray 
                        },
                    );
                break;

           

            
        }

        if (l_AgentInPageNavItems) {
            l_AgentInPageNavItems.splice(l_AgentInPageNavItems.findIndex(aipni => aipni.route == url), 1);
        }

        return l_AgentInPageNavItems;
    }

    public buildMemberPageNavItems(url: string): InPageNavItem[] {
        let l_MemberInPageNavItems: InPageNavItem[] = new Array<InPageNavItem>();

        let l_MenuLinks: MenuLink[];
        switch (true) {
            case url.startsWith(MemberPaths.Dashboard):
                l_MemberInPageNavItems = null;
                break;

            case url.startsWith(MemberPaths.Benefits):
                l_MemberInPageNavItems.push({ 
                        icon: SvgMatType.Dashboard, 
                        label: 'Benefit Dashboard', 
                        key: 'benefitDashboard', 
                        route: MemberPaths.BenefitsDashboard, 
                        customClass: SVGNavBarColors.iconBlue 
                    },{ 
                        icon: SvgMatType.AvailableBenefits,
                        label: 'Available Benefits',
                        key: 'availableBenefits',
                        route: MemberPaths.Benefits,
                        customClass: SVGNavBarColors.iconBlue 
                    },{
                        icon: SvgMatType.MyBenefits,
                        label: 'My Benefits',
                        key: 'myBenefits',
                        route: MemberPaths.BenefitsMyBenefits,
                        customClass: SVGNavBarColors.iconMint
                    },{
                        icon: SvgMatType.Beneficiaries,
                        label: 'Beneficiaries',
                        key: 'beneficiaries',
                        route: MemberPaths.BenefitsBeneficiaries,
                        customClass: SVGNavBarColors.iconLavender 
                    }
                );

                if (this.sessionService.session.member.useYearRound)
                    l_MemberInPageNavItems.push({
                        icon: SvgMatType.LifeEventRequests,
                        label: 'Life Event Requests',
                        key: 'lifeEventRequests',
                        route: MemberPaths.BenefitsLifeEventRequests,
                        customClass: SVGNavBarColors.iconCyan 
                    });

                if (this.sessionService.session.member.showDependentVerification)
                    l_MemberInPageNavItems.push({
                        icon: SvgMatType.InsertDriveFile,
                        label: 'Dependent Verification',
                        key: 'dependentVerification',
                        route: MemberPaths.BenefitsDependentVerification,
                        customClass: SVGNavBarColors.iconPeach
                    });

                if (this.sessionService.session.member.isUSAePayEnabled)
                    l_MemberInPageNavItems.push({
                        icon: SvgMatType.SyncAlt,
                        label: 'Payment Informaiton',
                        key: 'paymentInformaiton',
                        route: MemberPaths.PaymentInformation,
                        customClass: SVGNavBarColors.iconMint
                    });

                l_MemberInPageNavItems.push({ 
                        icon: SvgMatType.BenefitSummaries,
                        label: 'Benefit Summaries',
                        key: 'benefitSummaries',
                        route: MemberPaths.DocumentsBenefitsSummaries,
                        customClass: SVGNavBarColors.iconGray 
                    },{
                        icon: SvgMatType.SyncAlt,
                        label: 'Change Requests',
                        key: 'benefitChangeRequests',
                        route: MemberPaths.BenefitsChangeRequests,
                        customClass: SVGNavBarColors.iconCoral
                    }
                );
                break;

            case url.startsWith(MemberPaths.Profile):
                if (this.sessionService.session?.member?.usePayrollModule && !this.sessionService.session.isAgent)
                    l_MemberInPageNavItems.push({ 
                        icon: SvgMatType.Dashboard,
                        label: 'Payroll Dashboard',
                        key: 'payrollDashboard',
                        route: MemberPaths.PayrollDashboard,
                        customClass: SVGNavBarColors.iconCyan
                    });
                else
                    l_MemberInPageNavItems.push({
                        icon: SvgMatType.Dashboard2,
                        label: 'Benefit Dashboard',
                        key: 'benefitDashboard',
                        route: MemberPaths.BenefitsDashboard,
                        customClass: SVGNavBarColors.iconBlue 
                    });

                l_MemberInPageNavItems.push({
                        icon: SvgMatType.Profile,
                        label: 'Member',
                        key: 'member',
                        route: MemberPaths.ProfileMember,
                        customClass: SVGNavBarColors.iconBlue
                    },{ 
                        icon: SvgMatType.Dependents,
                        label: 'Dependents',
                        key: 'dependents',
                        route: MemberPaths.ProfileDependents,
                        customClass: SVGNavBarColors.iconMint 
                    },{ 
                        icon: SvgMatType.Beneficiaries,
                        label: 'Beneficiaries',
                        key: 'beneficiaries',
                        route: MemberPaths.ProfileBeneficiaries,
                        customClass: SVGNavBarColors.iconCoral 
                    }
                );
                break;

            case url.startsWith(MemberPaths.Accounting):
                if (this.sessionService.session?.member?.usePayrollModule && !this.sessionService.session.isAgent)
                    l_MemberInPageNavItems.push({ 
                        icon: SvgMatType.Dashboard2,
                        label: 'Payroll Dashboard',
                        key: 'payrollDashboard',
                        route: MemberPaths.PayrollDashboard,
                        customClass: SVGNavBarColors.iconCyan
                    });
                else
                    l_MemberInPageNavItems.push({
                        icon: SvgMatType.Dashboard,
                        label: 'Benefit Dashboard',
                        key: 'benefitDashboard',
                        route: MemberPaths.BenefitsDashboard,
                        customClass: SVGNavBarColors.iconBlue 
                    });

                if (this.sessionService.session.member.showMemberAccounting)
                    l_MenuLinks.push({
                        label: 'Accounting Transations',
                        link: MemberPaths.AccountingTransactions,
                    });

                if (this.sessionService.session.member.isUSAePayEnabled)
                    l_MenuLinks.push({
                        label: 'Payment Informaiton',
                        link: MemberPaths.AccountingPaymentInformation,
                    });
                break;

            case url.startsWith(MemberPaths.Documents):
                if (this.sessionService.session?.member?.usePayrollModule && !this.sessionService.session.isAgent)
                    l_MemberInPageNavItems.push({ 
                        icon: SvgMatType.Dashboard2,
                        label: 'Payroll Dashboard',
                        key: 'payrollDashboard',
                        route: MemberPaths.PayrollDashboard,
                        customClass: SVGNavBarColors.iconCyan
                    });
                else
                    l_MemberInPageNavItems.push({
                        icon: SvgMatType.Dashboard,
                        label: 'Benefit Dashboard',
                        key: 'benefitDashboard',
                        route: MemberPaths.BenefitsDashboard,
                        customClass: SVGNavBarColors.iconBlue 
                    });
                
                l_MemberInPageNavItems.push({ 
                        icon: SvgMatType.BenefitDocs, 
                        label: 'Benefit Docs', 
                        key: 'benefits', 
                        route: MemberPaths.DocumentsBenefits, 
                        customClass: SVGNavBarColors.iconBlue 
                    },{ 
                        icon: SvgMatType.Company,
                        label: 'Company Docs',
                        key: 'company',
                        route: MemberPaths.DocumentsCompany,
                        customClass: SVGNavBarColors.iconMint 
                    },{
                        icon: SvgMatType.ComplianceDocs,
                        label: 'Compliance Docs',
                        key: 'compliance',
                        route: MemberPaths.DocumentsCompliance,
                        customClass: SVGNavBarColors.iconCoral
                    },{
                        icon: SvgMatType.Contacts,
                        label: 'Contacts',
                        key: 'contacts',
                        route: MemberPaths.DocumentsContacts,
                        customClass: SVGNavBarColors.iconLavender 
                    }
                );

                if (this.sessionService.session.member.useACAModule)
                    l_MemberInPageNavItems.push({ 
                            icon: SvgMatType.Article, 
                            label: 'Form 1095s', 
                            key: 'form1095s', 
                            route: MemberPaths.DocumentsForm1095, 
                            customClass: SVGNavBarColors.iconPeach 
                        },
                    );

                if (this.sessionService.session?.member?.usePayrollModule && !this.sessionService.session.isAgent)
                    l_MemberInPageNavItems.push({ 
                            icon: SvgMatType.InsertDriveFile, 
                            label: 'W2\'s', 
                            key: 'w2s', 
                            route: MemberPaths.DocumentsW2, 
                            customClass: SVGNavBarColors.iconGray 
                        },
                    );
                break;

            // case url.startsWith(MemberPaths.Relations):
            //     l_MenuLinks = [
            //         {
            //             label: 'Activity Log',
            //             link: MemberPaths.RelationsActivityLog,
            //         },{
            //             label: 'Open Follow Ups',
            //             link: MemberPaths.RelationsOpenFollowUps,
            //         },{
            //             label: 'Completed Follow Ups',
            //             link: MemberPaths.RelationsCompletedFollowUps,
            //         },
            //     ];
            //     break;

            case url.startsWith(MemberPaths.Payroll):
                l_MemberInPageNavItems.push({
                        icon: SvgMatType.Dashboard,
                        label: 'Payroll Dashboard',
                        key: 'payrollDashboard',
                        route: MemberPaths.PayrollDashboard,
                        customClass: SVGNavBarColors.iconCyan 
                    },{
                        icon: SvgMatType.PayStub,
                        label: 'Pay Stubs',
                        key: 'payStubs',
                        route: MemberPaths.PayrollPayStubs,
                        customClass: SVGNavBarColors.iconMint
                    },{
                        icon: SvgMatType.Resources,
                        label: 'Annual Statements',
                        key: 'annualStatements',
                        route: MemberPaths.PayrollAnnualStatements,
                        customClass: SVGNavBarColors.iconGray
                    },{
                        icon: SvgMatType.LocationOn,
                        label: 'Address',
                        key: 'address',
                        route: MemberPaths.PayrollAddress,
                        customClass: SVGNavBarColors.iconBlue
                    },{
                        icon: SvgMatType.Deductions,
                        label: 'Deductions',
                        key: 'deductions',
                        route: MemberPaths.PayrollDeductions,
                        customClass: SVGNavBarColors.iconMint
                    },{
                        icon: SvgMatType.DirectDeposit,
                        label: 'Direct Deposit',
                        key: 'directDeposit',
                        route: MemberPaths.PayrollDirectDeposit,
                        customClass: SVGNavBarColors.iconCoral
                    },{
                        icon: SvgMatType.FederalTax,
                        label: 'Federal Tax Details',
                        key: 'federalTaxDetails',
                        route: MemberPaths.PayrollFederalTaxDetails,
                        customClass: SVGNavBarColors.iconCyan
                    },{
                        icon: SvgMatType.StateTax,
                        label: 'State Tax Details',
                        key: 'stateTaxDetails',
                        route: MemberPaths.PayrollStateTaxDetails,
                        customClass: SVGNavBarColors.iconLavender
                    },{
                        icon: SvgMatType.PTO,
                        label: 'PTO / Sick Hours',
                        key: 'ptoSickHours',
                        route: MemberPaths.PayrollPTOSickHours,
                        customClass: SVGNavBarColors.iconPeach 
                    }
                );
                break;
        }

        if (l_MemberInPageNavItems) {
            l_MemberInPageNavItems.splice(l_MemberInPageNavItems.findIndex(mipni => mipni.route == url), 1);
        }

        return l_MemberInPageNavItems;
    }

    public buildDashboardInPageNavItems(): InPageNavItem[] {
        let l_InPageNavItems: InPageNavItem[] = new Array<InPageNavItem>();

        if (this.sessionService.session?.member?.usePayrollModule && !this.sessionService.session.isAgent)
            l_InPageNavItems.push({ icon: SvgMatType.Dashboard, label: 'Payroll Dashboard', key: 'payrollDashboard', route: MemberPaths.PayrollDashboard, customClass: SVGNavBarColors.iconCyan });

        l_InPageNavItems.push({ icon: SvgMatType.Dashboard2, label: 'Benefit Dashboard', key: 'benefitDashboard', route: MemberPaths.BenefitsDashboard, customClass: SVGNavBarColors.iconBlue });

        if (this.sessionService.session?.member?.usePayrollModule && !this.sessionService.session.isAgent)
            l_InPageNavItems.push({ icon: SvgMatType.PayStub, label: 'Pay Stubs', key: 'payStubs', route: MemberPaths.PayrollPayStubs, customClass: SVGNavBarColors.iconCoral });

        l_InPageNavItems.push({ icon: SvgMatType.AvailableBenefits, label: 'Available Benefits', key: 'availableBenefits', route: MemberPaths.Benefits, customClass: SVGNavBarColors.iconMint });

        if (this.sessionService.session?.member?.useYearRound)
            l_InPageNavItems.push({ icon: SvgMatType.LifeEventRequests, label: 'Life Event Requests', key: 'lifeEventRequests', route: MemberPaths.BenefitsLifeEventRequests, customClass: SVGNavBarColors.iconCyan });

        if (this.sessionService.session?.member?.showDependentVerification)
            l_InPageNavItems.push({ icon: SvgMatType.InsertDriveFile, label: 'Dependent Verification', key: 'dependentVerification', route: MemberPaths.BenefitsDependentVerification, customClass: SVGNavBarColors.iconPeach });

        l_InPageNavItems.push({ icon: SvgMatType.Beneficiaries, label: 'Benefit Summaries', key: 'benefitSummaries', route: MemberPaths.DocumentsBenefitsSummaries, customClass: SVGNavBarColors.iconGray });

        if (this.sessionService.session?.member?.isUSAePayEnabled)
            l_InPageNavItems.push({ icon: SvgMatType.SyncAlt, label: 'Payment Informaiton', key: 'paymentInformaiton', route: MemberPaths.PaymentInformation, customClass: SVGNavBarColors.iconMint });

        return l_InPageNavItems;
    }
};